import {
  cancelExchange as internalCancelExchange,
  exchangeElectronMessage as internalExchangeElectronMessage,
  sendElectronMessage as internalSendElectronMessage,
} from './shared.app-utils';
import {
  CommonMessage,
  CommonMessageForResponse,
  CommonMessageResponse,
  CommonMessageType,
} from './shared.types';

export {CommonMessageType, AppType} from './shared.types';
export type {
  CommonMessageForResponse,
  CommonMessageResponse,
} from './shared.types';
export {isElectron} from './shared.app-utils';

/**
 * Sends a message to the electron backend without repeating the "window.postMessage" stuff every time.
 */
export const sendElectronMessage = (message: CommonMessage): void =>
  internalSendElectronMessage(message);

/**
 * Sends a message with the specified messageType to the lexian-browser and handles the response's
 * payload with the specified responsePayloadHandler.
 *
 * If the type is not included in the response the event is _not_ handled.
 */
export const exchangeElectronMessage = <T extends CommonMessageForResponse>(
  message: T,
  responsePayloadHandler: (response: CommonMessageResponse[T['type']]) => void
): void => internalExchangeElectronMessage(message, responsePayloadHandler);

/**
 * Cancel an exception for the given message type.
 */
export const cancelExchange = (
  type: CommonMessageType | CommonMessageType
): void => internalCancelExchange(type);
